/* eslint-disable complexity */
/* eslint-disable no-unreachable */
/* eslint-disable lines-around-comment */

// Copyright (c) 2019 Deere & Company

export const bindOnConfirmActions = (action, claim, actions) => ({
    addRep: actions.addRep.bind(null, claim),
    adjust: actions.adjust.bind(null, action),
    copy: actions.copy.bind(null, claim),
    delete: actions.delete.bind(null, action),
    pushxml: actions.pushxml.bind(null, action),
    reconcile: actions.reconcile.bind(null, action),
    unreconcile: actions.unreconcile.bind(null, action),
    unsubmit: actions.unsubmit.bind(null, action)
});

export const confirmationModalMap = (action, onClose, confirmActions) => {

    switch (action.id) {

    case 'COPY_CLAIM':
        return {
            confirmMessage: 'CONFIRM_COPY_CLAIM',
            isOpen: true,
            onClose,
            onConfirm: () => {

                confirmActions.copy();
                onClose();

            },
            title: 'COPY_CLAIM'
        };
        break;
    case 'DEL':
        return {
            confirmMessage: 'CONFIRM_DELETE_CLAIM',
            isOpen: true,
            onClose,
            onConfirm: () => {

                confirmActions.delete();
                onClose();

            },
            title: 'DELETE_CLAIM'
        };
        break;
    case 'PUSH_XML':
        return {
            confirmMessage: 'CONFIRM_RESEND_XML',
            isOpen: true,
            onClose,
            onConfirm: () => {

                confirmActions.pushxml();
                onClose();

            },
            title: 'RESEND_XML'
        };
        break;
    case 'RECONCILE':
        return {
            confirmMessage: 'CONFIRM_RECONCILE_CLAIM',
            isOpen: true,
            onClose,
            onConfirm: () => {

                confirmActions.reconcile();
                onClose();

            },
            title: 'RECONCILE_CLAIM'
        };
        break;

    case 'REQ_ADDL':
        return {
            confirmMessage: 'CONFIRM_ADJUST_CLAIM',
            isOpen: true,
            onClose,
            onConfirm: () => {

                confirmActions.adjust();
                onClose();

            },
            title: 'ADJUST_CLAIM'
        };
        break;
    case 'UNRECONCIL':
        return {
            confirmMessage: 'CONFIRM_UNRECONCILE_CLAIM',
            isOpen: true,
            onClose,
            onConfirm: () => {

                confirmActions.unreconcile();
                onClose();

            },
            title: 'UNRECONCILE_CLAIM'
        };
        break;
    case 'UNSUB':
        return {
            confirmMessage: 'CONFIRM_EDIT_CLAIM',
            isOpen: true,
            onClose,
            onConfirm: () => {

                confirmActions.unsubmit();
                onClose();

            },
            title: 'UNSUBMIT_CLAIM'
        };
        break;

    default:
        return false;
    }

};




// WEBPACK FOOTER //
// ./src/claim/incentive/services/confirmation-modal-map.js